module.exports = __webpack_public_path__ + "img/bvt.78bef910.svg";